module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header-12df2b83c03a11064765dc47acfa8e38.jpg";